import { Variable, variablesToFieldsInfo } from '@microservices/wiskey-react-components'

import { getRSqlBySearch } from '@helpers'
import {
  ACTION_CODE,
  EVENT_CODE,
  ROSTER_DUTY_RSQL_FILTER_EXAMPLE,
  ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_DUTY_END_EXAMPLE,
  ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_DUTY_START_EXAMPLE,
  ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_STAFF_REF_EXAMPLE,
  ROSTER_PERSON_QUALIFICATION_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_QUAL_ID,
  TIME_LINE_UPDATE_COMMAND_FOR_DROP_ACTION_GET_ID_EXAMPLE,
} from '@constants'
import { TimelineActionMeta } from '@types'

type Props = {
  eventCode?: EVENT_CODE | null
  actionCode?: ACTION_CODE
  meta?: TimelineActionMeta
}

export const getTimelineCommandScriptConfig = (props: Props) => {
  const { eventCode, actionCode, meta } = props

  if (eventCode === EVENT_CODE.ON_DROP && actionCode === ACTION_CODE.EXECUTE_COMMAND) {
    const cellInfo = [
      {
        name: 'cellId',
        type: 'string',
        description: 'Unique timeline cell key',
      },
      {
        name: 'rowId',
        type: 'string',
      },
      {
        name: 'columnId',
        type: 'string',
      },
      {
        name: 'columnInfo',
        type: meta?.scriptAdditionalInfo?.columnFields || 'any',
        description: 'Column info',
      },
      {
        name: 'rowData',
        type: meta?.scriptAdditionalInfo?.rowData || 'any',
        description: 'Full row payload',
      },
    ]

    const variables: Variable[] = [
      {
        name: 'target',
        type: cellInfo,
        description: 'Destination cell — where the item was dropped',
      },
      {
        name: 'source',
        type: cellInfo,
        description: 'Origin cell — where the item was dragged from',
      },
      {
        name: 'item',
        type: meta?.scriptAdditionalInfo?.objectXItemFields || 'any',
        description: 'The dragged object X item (event)',
      },
    ]

    return {
      examples: [
        TIME_LINE_UPDATE_COMMAND_FOR_DROP_ACTION_GET_ID_EXAMPLE,
        ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_STAFF_REF_EXAMPLE,
        ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_DUTY_END_EXAMPLE,
        ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_DUTY_START_EXAMPLE,
        ROSTER_PERSON_QUALIFICATION_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_QUAL_ID,
      ],
      variables: [{ name: 'srcObj', type: variables }],
      fieldsInfo: variablesToFieldsInfo(variables, 'srcObj'),
    }
  }

  const variables = [
    {
      name: 'startDate',
      type: 'string',
      description: '',
    },
    {
      name: 'endDate',
      type: 'string',
      description: '',
    },
    {
      name: 'objectYSAFilters',
      type: 'any',
      description: 'Active search assistant filters applied to Object Y',
    },
    {
      name: 'objectXSAFilters',
      type: 'any',
      description: 'Active search assistant filters applied to Object X',
    },
    {
      name: 'objectXColumnsObjectSAFilters',
      type: 'any',
      description: 'Active search assistant filters applied to the columns in Object X',
    },
    {
      name: 'getRSqlBySearch',
      type: typeof getRSqlBySearch,
    },
  ]

  return {
    examples: [ROSTER_DUTY_RSQL_FILTER_EXAMPLE],
    variables: [
      {
        name: 'srcObj',
        type: variables,
      },
    ],
    fieldsInfo: variablesToFieldsInfo(variables, 'srcObj'),
  }
}
